import { createSlice, PayloadAction } from "@reduxjs/toolkit";

// NOTE: The default strings "Untitled form" and "Form description" in initialState
// are kept as plain English keys here (Redux state should be language-agnostic).
// Translate them in the component that renders these values using:
//   t("Untitled form") and t("Form description")

const initialState = {
  formSectionDetail: {
    title: "Untitled form",
    description: "Form description",
  },
  formQuestionDetail: [
    {
      question: "Test",
      options: {},
      formType: "",
      id: 1,
      requiredSwitch: false,
    },
  ],
};

export const formSlice = createSlice({
  name: "formbuilder",
  initialState,
  reducers: {
    formtitle: (state, action) => {
      state.formSectionDetail = action.payload;
    },
    formQuestions: (state, action) => {
      state.formQuestionDetail = JSON.parse(JSON.stringify(action?.payload));
    },
  },
});

export const selectFormDetail = (state) =>
  state?.formbuilder?.formSectionDetail;

export const { formtitle } = formSlice.actions;

export const selectFormQuestions = (state) =>
  state.formbuilder?.formQuestionDetail;

export const { formQuestions } = formSlice.actions;

export default formSlice.reducer;
